import { Column } from '../flex';
import { IFullScreenLoadingSpinnerProps } from './FullScreenLoadingSpinner';
import { LoadingSpinner } from './LoadingSpinner';

const OVERLAY_Z_INDEX = 100; // modal 위에 보여질 경우가 없다고 판단 -> 임의의 적당한 값으로 100 사용.

export const FullScreenOverlayLoadingSpinner = ({
  condition,
  includeFilter = false,
  children,
  spinnerCondition = true,
  spinnerConditionChildren,
}: IFullScreenLoadingSpinnerProps) => {
  return condition ? (
    children
  ) : spinnerCondition ? (
    <>
      {children}
      <Column
        width="100%"
        position="absolute"
        height={
          includeFilter
            ? 'web-fit-except-gnb-except-filter'
            : 'web-fit-except-gnb'
        }
        placeItems="center"
        zIndex={OVERLAY_Z_INDEX}>
        <LoadingSpinner />
      </Column>
    </>
  ) : (
    spinnerConditionChildren
  );
};
